// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"7c649fd2","314":"f853a26d","349":"27f37650","583":"0da92ca5"}[chunkId] + ".chunk.css";
};